const isBlank = (value: unknown) =>
  value === undefined ||
  value === null ||
  value === "" ||
  (Array.isArray(value) && value.length === 0);

const hasImage = (image: any) =>
  Boolean(image?.original_image?.original_image_relative_path || image?.original_image?.Thumbnail);

// Scoped to the content types KIWI-6288 covers. This helper runs in the generic save/load
// path shared by every schema-based type, so without this gate the social_share_* defaults
// would alter public OG/SEO meta for all of them, tenant-wide.
const DEFAULTING_CONTENT_TYPES = new Set(["gallery", "profile"]);

export const applyContentFieldDefaults = <T extends Record<string, any>>(
  contentInstance: T,
  contentType?: string,
): T => {
  if (!contentInstance) return contentInstance;
  if (!DEFAULTING_CONTENT_TYPES.has((contentType || "").toLowerCase())) return contentInstance;

  const next: Record<string, any> = { ...contentInstance };

  if (
    Object.hasOwn(next, "notification_title") &&
    isBlank(next.notification_title) &&
    !isBlank(next.title)
  ) {
    next.notification_title = next.title;
  }

  if (
    Object.hasOwn(next, "notification_desc") &&
    isBlank(next.notification_desc) &&
    !isBlank(next.description)
  ) {
    next.notification_desc = next.description;
  }

  if (
    Object.hasOwn(next, "notification_image") &&
    !hasImage(next.notification_image) &&
    hasImage(next.banner)
  ) {
    next.notification_image = next.banner;
  }

  if (
    Object.hasOwn(next, "social_share_title") &&
    isBlank(next.social_share_title) &&
    !isBlank(next.title)
  ) {
    next.social_share_title = next.title;
  }

  if (
    Object.hasOwn(next, "social_share_desc") &&
    isBlank(next.social_share_desc) &&
    !isBlank(next.description)
  ) {
    next.social_share_desc = next.description;
  }

  if (
    Object.hasOwn(next, "social_share_image") &&
    !hasImage(next.social_share_image) &&
    hasImage(next.banner)
  ) {
    next.social_share_image = next.banner;
  }

  return next as T;
};
